import { makeAutoObservable } from 'mobx'
import { ExerciseInWorkout } from '@entities/exercise'

class WorkoutExecutionStore {
	private exercises_: ExerciseInWorkout[] = []

	constructor() {
		makeAutoObservable(this)
	}

	public setExercises = (exercises: ExerciseInWorkout[]): void => {
		this.exercises_ = exercises
	}

	public getExerciseByOrder = (order: number): ExerciseInWorkout | null => {
		return this.exercises_.find(exercise => exercise.order === order) || null
	}

	public get exercisesAmount(): number {
		return this.exercises_.length
	}
}

export const workoutExecutionStore = new WorkoutExecutionStore()
